import React from 'react';
import { createSvgIcon } from '@mui/material';

export const SmallDownArrowIcon = createSvgIcon(
  <svg width="15" height="6" viewBox="-4 0 10 4" fill="currentColor">
    <path d="M0 0L6 0L3 4Z" />
  </svg>,
  'SmallDownArrow'
);
